import { render } from "./ChatConnectionStatus.vue?vue&type=template&id=5282e97a&scoped=true"
const script = {}

import "./ChatConnectionStatus.vue?vue&type=style&index=0&id=5282e97a&scoped=true&lang=css"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5282e97a"]])

export default __exports__